__turbopack_context__.v({
  "address": "styles-module-scss-module__gSwrmG__address",
  "close_button": "styles-module-scss-module__gSwrmG__close_button",
  "focus-visible": "styles-module-scss-module__gSwrmG__focus-visible",
  "header": "styles-module-scss-module__gSwrmG__header",
  "like_button": "styles-module-scss-module__gSwrmG__like_button",
  "modal": "styles-module-scss-module__gSwrmG__modal",
  "modal_body_class": "styles-module-scss-module__gSwrmG__modal_body_class",
  "modal_button": "styles-module-scss-module__gSwrmG__modal_button",
  "modal_inner": "styles-module-scss-module__gSwrmG__modal_inner",
  "modal_overlay": "styles-module-scss-module__gSwrmG__modal_overlay",
  "social_buttons": "styles-module-scss-module__gSwrmG__social_buttons",
});
